export const PLATFORM_TYPE = Object.freeze({
  WEB: 'web',
  BROWZWEAR: 'browzwear'
})
